module.exports = __webpack_public_path__ + "static/img/u2021.d1026e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datas/u2021.png
// module id = W16y
// module chunks = 209